import React from 'react';
import { DropdownContainer } from './style';
import { monthlyDaysOptions } from 'app/pages/reports/util';
import { Dropdown } from 'lib/components';
import { CustomReportModalFormikValues } from '../types';
import { useFormikContext } from 'formik';
import { FREQUENCY_TYPE } from 'lib/components/frequency/constants';
import { useTranslation } from 'react-i18next';

const options = [
  ...monthlyDaysOptions,
  {
    label: 'Last',
    value: 'L',
  },
];
export const MonthlyFrequency = () => {
  const { setFieldValue, values } =
    useFormikContext<CustomReportModalFormikValues>();
  const { t } = useTranslation();

  const getDropdownValue = () => {
    const current = values?.recurrings?.frequency?.split(';')[1];
    return options.find(option => option.value === current);
  };
  return (
    <DropdownContainer
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <span>{t('Send on day')}</span>
      <Dropdown
        width={88}
        placeholder='Select day of month'
        value={getDropdownValue()}
        creatable={false}
        onChange={newValue => {
          setFieldValue(
            'recurrings.frequency',
            `${FREQUENCY_TYPE.MONTHLY};${newValue.value}`
          );
        }}
        options={options}
      />
      <span>{t('of month')}</span>
    </DropdownContainer>
  );
};
